import airports from './airports'
import bookings from './bookings'
import errors from './errors'
import flights from './flights'
import passengers from './passengers'
import requests from './requests'
import search from './search'
import seatTrade from './seatTrade'
import serviceStatus from './serviceStatus'
import ssrs from './ssrs'
import tourOperators from './tourOperators'
import users from './users'

export default [
  ...airports,
  ...bookings,
  ...errors,
  ...flights,
  ...passengers,
  ...requests,
  ...search,
  ...seatTrade,
  ...ssrs,
  ...tourOperators,
  ...users,
  ...serviceStatus,
]
